import React from "react";

function About() {
  const paragraphStyle = {
    color: '#1f2937',
    fontSize: '1.1rem',
    lineHeight: 1.75,
    marginBottom: '1.25rem',
    textAlign: 'left',
  };

  return (
    <div style={{ background: '#f9fafb', minHeight: '100vh', padding: '3rem 1rem' }}>
      <div style={{ maxWidth: '760px', margin: '0 auto', background: '#fff', borderRadius: '12px', boxShadow: '0 4px 16px rgba(0,0,0,0.07)', padding: '2.5rem 2rem' }}>
        <h1 style={{ color: '#f97316', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1.5rem', textAlign: 'center' }}>
          About Us
        </h1>
        <p style={paragraphStyle}>
          We are an auto wash company that provides quality and value. We did not come to the market to be a traditional one-stop car wash, but rather to provide an Express service for people on the go, servicing everything from cars to caravans/panel vans.
        </p>
        <p style={paragraphStyle}>
          Not everyone is able to set aside 2 to 3 hours on a regular basis to maintain their vehicle properly, especially after spending time in traffic. If you already have a preferred place for a complete deep clean when you have time to spare, we want you to maintain that relationship. Check us out when you need routine upkeep or a quality exterior wash to boost confidence. We provide a value exterior wash using quality foams and with Reverse Osmosis water. Our standard is efficiency: once you enter the compound, even if you are last in line, we aim to complete your wash within an hour.
        </p>
        <p style={paragraphStyle}>
          Come check us out! Simply drive in or book an appointment online. If you have any issues, call or WhatsApp us at 306-7846 or 481-1471. We are located in Chaguanas—the first building on the right after turning into Mulchan Seuchan Road from the Endeavour flyover/Medford gas station side. The spot is also known as &quot;The Old Flow Car Park.&quot; You can also find us on Google Maps by searching &quot;Rocket Express Auto Wash.&quot;
        </p>
        <p style={{ ...paragraphStyle, marginBottom: 0 }}>
          When booking online, you have up to 2 hours before your appointment time to cancel without any penalty. If you need to cancel, simply log back in and click &quot;cancel&quot; on the appointments page, or call us to clear the spot.
        </p>
      </div>
    </div>
  );
}

export default About;
